export default __webpack_public_path__ + "static/media/headsetIcon.bf8ed2f9.svg";